import { Injectable } from '@angular/core';
import { WindowRefService } from './window-ref.service';
@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  private window;

  constructor(private _windowRef: WindowRefService) {
    this.window = _windowRef.nativeWindow;
  }

  private pingHome(obj) {
    if (obj) this.window.dataLayer.push(obj);
  }

  getProductName(url) {
    const regex = /\/dashboard\/souscription\/([^?]+)/;
    let productName = '';
    const match = url.match(regex);
    if (match && match.length > 1) {
      productName = match[1];
    }
    return productName;
  }

  getStepName(stepName, url) {
    let productName = this.getProductName(url);
    const step = {
      event: 'souscription',
      step: stepName,
      product: productName,
    };
    this.pingHome(step);
  }
}
